import React, { lazy } from 'react';
import ReactDOM from 'react-dom/client';
import { NestedRootRoutes } from 'shared/src/components/NestedRoutes';
import reportWebVitals from './reportWebVitals';
import { Route, Switch } from 'wouter';
import { ErrorBoundary } from 'shared/src/components';
import * as Sentry from 'shared/src/setupSentry';
import dayjs from 'dayjs';
import Utc from 'dayjs/plugin/utc';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import isBetween from 'dayjs/plugin/isBetween';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import relativeTime from 'dayjs/plugin/relativeTime';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import timezone from 'dayjs/plugin/timezone';
import { withLoadingSuspense } from 'admin/src/hoc';
import { LicenseManager, ModuleRegistry, ValidationModule } from 'ag-grid-enterprise';

import 'react-toastify/dist/ReactToastify.css';
import 'shared/src/index.css';

const WebApp = lazy(() => import('admin/src/WebApp'));
const DesktopApp = lazy(() => import('admin/src/DesktopApp'));
const EasyOrderApp = lazy(() => import('admin/src/EasyOrderApp'));

if (import.meta.env.VITE_AG_GRID_LICENSE_KEY) LicenseManager.setLicenseKey(import.meta.env.VITE_AG_GRID_LICENSE_KEY);
if (import.meta.env.NODE_ENV !== 'production') ModuleRegistry.registerModules([ValidationModule]);

if (!import.meta.env.DEV) Sentry.initialSetup('admin');
dayjs.extend(Utc);
dayjs.extend(LocalizedFormat);
dayjs.extend(customParseFormat);
dayjs.extend(isBetween);
dayjs.extend(advancedFormat);
dayjs.extend(relativeTime);
dayjs.extend(timezone);
dayjs.extend(isSameOrAfter);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <ErrorBoundary>
    <Switch>
      <Route path="/app/:any*">
        <NestedRootRoutes base="/app">{withLoadingSuspense(EasyOrderApp)()}</NestedRootRoutes>
      </Route>
      <Route path="/admin/:any*">
        <NestedRootRoutes base="/admin">{withLoadingSuspense(DesktopApp)()}</NestedRootRoutes>
      </Route>
      <Route path="/:any*">
        <NestedRootRoutes>{withLoadingSuspense(WebApp)()}</NestedRootRoutes>
      </Route>
    </Switch>
  </ErrorBoundary>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
